import {
  useInfiniteQuery,
  useQuery,
  useQueryClient
} from '@tanstack/react-query'

import { identityClient } from '@/api/identity-client'

export const useOidcClients = () =>
  useInfiniteQuery({
    queryKey: ['identity', 'clients'],
    queryFn: ({ pageParam }) => identityClient.list(pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (page) => page.next_cursor || undefined,
    retry: false,
    refetchOnWindowFocus: false
  })

export const useOidcClient = (id: string) =>
  useQuery({
    queryKey: ['identity', 'client', id],
    queryFn: () => identityClient.get(id),
    enabled: Boolean(id),
    retry: false,
    refetchOnWindowFocus: false
  })

export const useOidcOrganizations = (id: string) =>
  useQuery({
    queryKey: ['identity', 'organizations', id],
    queryFn: () => identityClient.organizations(id),
    enabled: Boolean(id),
    retry: false,
    refetchOnWindowFocus: false
  })

export const useRefreshIdentity = () => {
  const queryClient = useQueryClient()

  return () => queryClient.invalidateQueries({ queryKey: ['identity'] })
}
